const Form = require("app/components/forms/Form");
const axios = require("axios");
const debounce = require("app/util/debounce");
const PropTypes = require("prop-types");
const assign = require("object-assign");

class DynamicForm extends Form {

	static get propTypes() {
		return {
			performValidationOnLoad: PropTypes.bool
		};
	}

	static get defaultProps() {
		return {
			performValidationOnLoad: false
		};
	}

	constructor(props) {
		super(props);

		this.fields = {};
		this.state = assign({}, this.state, {
			pendingValidation: [],
			changedFields: [],
			validated: false,
			submitted: false
		});
	}

	componentDidMount() {
		if (this.props.performValidationOnLoad) {
			//this.performValidation();
		}
	}

	get validationUrl() {
		// ...
	}

	performValidation() {
		const form = this.bodyElement.querySelector("form");

		if (form == undefined) {
			return;
		}

		axios.post(this.validationUrl, this.buildPayload(form))
			.then(() => {
				this.onValidationSuccess();
			})
			.catch(error => {
				this.onValidationError(error.response.data);
			});
	}

	queueValidation = debounce(1000, () => {
		this.performValidation();
	});

	validate = () => {
		this.queueValidation();
	};

	onChange(name) {
		return () => {

			this.setState(oldState => {
				let state = assign({}, oldState);

				if (this.state.pendingValidation.indexOf(name) === -1) {
					// Push changed field
					state.pendingValidation.push(name);

					// Remove existing errors (so we don't display it straight away)
					if (state.errors && state.errors[name]) {
						delete state.errors[name];
					}
				}

				if (this.state.changedFields.indexOf(name) === -1) {
					state.changedFields.push(name);
				}

				return state;
			});

			this.validate();
		};
	}

	onComplete(response) {
		this.setState({
			loading: false,
			validated: true,
			submitted: true,
			pendingValidation: [],
			message: response ? response.message : this.state.message
		});
	}

	onError(response) {
		if (response.errors) {
			this.setState({
				errors: response.errors,
				loading: false,
				validated: true,
				submitted: true,
				pendingValidation: []
			});
		}
	}

	onValidationSuccess() {
		this.setState({
			errors: null,
			pendingValidation: [],
			loading: false,
			validated: true
		});
	}

	onValidationError(response) {
		if (response.errors) {
			this.setState({
				errors: response.errors,
				pendingValidation: [],
				loading: false,
				validated: true
			});
		}
	}

	shouldRenderValidation(name) {
		const result = this.state.validated &&
			(this.state.pendingValidation.indexOf(name) === -1) &&
			(this.isValid(name) || (this.state.changedFields.indexOf(name) > -1));

		if (result && this.bodyElement) {
			const field = this.bodyElement.querySelector(`[name="${name}"]`);

			if (field && this.isValid(name)) {
				return field.value.length > 0;
			}
		}

		return result;
	}

	shouldRenderError(name) {
		return this.state.validated && (
			this.state.submitted ||
			(this.state.changedFields.indexOf(name) > -1)
		);
	}

	isValid(name) {
		return (this.state.errors == undefined) || (this.state.errors[name] == undefined);
	}

	renderValidity(name) {
		if (!this.shouldRenderValidation(name)) {
			return;
		}

		let className = "validity ";
		className += this.isValid(name) ? "valid" : "invalid";
		return (<div className={className}></div>);
	}

	renderError(name, extraClass = null) {
		if (!this.shouldRenderError(name)) {
			return;
		}

		const className = "form-error" + (extraClass ? ` ${extraClass}` : "");

		if (!this.isValid(name)) {
			return (<div className={className}>{this.state.errors[name][0]}</div>)
		}
	}

}

module.exports = DynamicForm;